import React from 'react';
import ReactDOM from 'react-dom/client';
import 'moment/locale/ko'
import { BrowserRouter } from "react-router-dom";
import {createTheme, ThemeProvider} from "@mui/material";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import './index.css';
import ScrollToTop from "./components/common/ScrollToTop";
import App from './App';

const theme = createTheme({
    typography: {
        fontFamily: ["Noto Sans KR", "sans-serif", "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue"].join(",")
    }
})

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
    <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='ko'>
            <BrowserRouter>
                <ScrollToTop />
                <App/>
            </BrowserRouter>
        </LocalizationProvider>
    </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

